var _mobileDefinitionLink;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _require = require("aphrodite"),
    StyleSheet = _require.StyleSheet,
    css = _require.css;

var React = require("react");
var _ = require("underscore");

var Changeable = require("../mixins/changeable.jsx");
var PerseusApi = require("../perseus-api.jsx");
var Renderer = require("../renderer.jsx");
var mediaQueries = require("../styles/media-queries.js");
var styleConstants = require("../styles/constants.js");

var Definition = React.createClass({
    displayName: "Definition",

    propTypes: _extends({}, Changeable.propTypes, {
        apiOptions: PerseusApi.Options.propTypes,
        definition: React.PropTypes.string,
        togglePrompt: React.PropTypes.string,
        trackInteraction: React.PropTypes.func.isRequired
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            togglePrompt: "define me",
            definition: "definition goes here"
        };
    },

    getInitialState: function getInitialState() {
        return {
            expanded: false,
            belowScreen: false,
            contentOffsetLeft: 0,
            contentOffsetLeftMobile: 0,
            contentWidth: 0,
            contentWidthMobile: 0,
            contentMarginTop: arrowHeight
        };
    },

    componentDidMount: function componentDidMount() {
        document.addEventListener("click", this.handleClick);
    },

    componentWillUnmount: function componentWillUnmount() {
        document.removeEventListener("click", this.handleClick);
    },

    handleClick: function handleClick(event) {
        var elem = event.target;
        var shouldClose = true;
        while (elem) {
            // If the clicked element is outside the definition box
            // close the definition box
            if (elem === this.content || elem === this.container) {
                shouldClose = false;
                break;
            }
            elem = elem.parentNode;
        }

        if (shouldClose) {
            this.close();
        }
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    close: function close() {
        this.setState({
            expanded: false
        });
    },

    getUserInput: function getUserInput() {
        return {};
    },

    simpleValidate: function simpleValidate(rubric) {
        return Definition.validate(this.getUserInput(), rubric);
    },

    // check if the definition is fully visible on the bottom
    _definitionBelowScreen: function _definitionBelowScreen() {
        var windowBottom = window.innerHeight;
        var bottom = this.container.getBoundingClientRect().bottom;
        return bottom > windowBottom - this.content.offsetHeight;
    },

    // TODO(audrey): think of a better way to have the definition always appear
    // on screen. Currently, the marginTop and absolute positions of the arrow
    // and the definition div are adjusted. Could also consider having
    // dynamic flipping.
    _checkDefinitionPosition: function _checkDefinitionPosition() {
        var _this = this;

        // need to wait for aphrodite styles to be rendered
        // so they can accessed for measurements in positionContent
        setTimeout(function () {
            _this._positionContentHorizontally();
            if (_this._definitionBelowScreen()) {
                _this.setState({
                    belowScreen: true
                }, _this._positionContentVertically);
            } else {
                _this.setState({
                    belowScreen: false
                }, _this._positionContentVertically);
            }
        }, 0);
    },

    /**
    * This function sets the definition boxes' vertical positions depending
    * on whether the definition should appear above or below. The positions
    * are affected by how long the definition is.
    */
    _positionContentVertically: function _positionContentVertically() {
        if (this.state.belowScreen) {
            var contentHeight = this.content.offsetHeight;
            // slight hack to better align the bottom of the arrow
            // with the rest of the definition box
            var contentMarginTop = -contentHeight - 2 * arrowHeight - 4;
            this.setState({
                contentMarginTop: contentMarginTop
            });
        } else {
            this.setState({
                contentMarginTop: arrowHeight
            });
        }
    },

    _onClick: function _onClick() {
        // close all other open definitions if opening definition
        if (!this.state.expanded) {
            var definitionWidgets = this.props.findWidgets("definition");
            for (var _iterator = definitionWidgets, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                var _ref;

                if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done) break;
                    _ref = _i.value;
                }

                var widget = _ref;

                if (widget !== this) {
                    widget.close();
                }
            }
        }

        this.setState({
            expanded: !this.state.expanded
        }, this._checkDefinitionPosition);
        this.props.trackInteraction();
    },

    _onMouseOver: function _onMouseOver() {
        this.setState({
            expanded: true
        }, this._checkDefinitionPosition);
        this.props.trackInteraction();
    },

    _onMouseOut: function _onMouseOut() {
        this.setState({
            expanded: false
        });
        this.props.trackInteraction();
    },

    /**
    * This function sets the definition boxes' widths so that the complete box
    * is visible on the screen and spans the entire width. It also makes sure
    * the content is centered correctly.
    */
    _positionContentHorizontally: function _positionContentHorizontally() {
        // container is the word to be defined
        // content is the actual definition
        var documentWidth = document.body.clientWidth;
        var marginWidth = this.container.parentElement.parentElement.offsetLeft;
        var contentWidth = documentWidth - 2 * marginWidth;
        var contentWidthMobile = documentWidth - marginWidth;
        var contentOffsetLeft = this.container.offsetLeft - marginWidth;
        var contentOffsetLeftMobile = this.container.offsetLeft;

        this.setState({
            contentWidth: contentWidth,
            contentWidthMobile: contentWidthMobile,
            contentOffsetLeft: -contentOffsetLeft,
            contentOffsetLeftMobile: -contentOffsetLeftMobile
        });
    },

    render: function render() {
        var _this2 = this;

        var _props$apiOptions = this.props.apiOptions,
            readOnly = _props$apiOptions.readOnly,
            isMobile = _props$apiOptions.isMobile;


        var linkAnchor = this.props.togglePrompt;

        var link = void 0;

        var href = readOnly ? null : "javascript:void(0)";
        var onClick = readOnly ? null : this._onClick;
        var onMouseOver = this._onMouseOver;
        var onMouseOut = this._onMouseOut;

        if (isMobile) {
            link = React.createElement(
                "a",
                {
                    className: css(styles.mobileDefinitionLink),
                    href: href,
                    onClick: onClick
                },
                linkAnchor
            );
        } else {
            link = React.createElement(
                "a",
                {
                    className: css(styles.definitionLink),
                    href: href,
                    onMouseOver: onMouseOver,
                    onMouseOut: onMouseOut
                },
                linkAnchor
            );
        }

        var expandedStyle = isMobile ? styles.contentExpandedMobile : styles.contentExpanded;

        var arrowTransform = this.state.belowScreen ? "scale(1, -1)" : "scale(1, 1)";

        return React.createElement(
            "div",
            {
                className: css(styles.container),
                ref: function ref(e) {
                    return _this2.container = e;
                }
            },
            React.createElement(
                "div",
                { className: css(styles.linkContainer) },
                link,
                this.state.expanded && React.createElement(
                    "svg",
                    {
                        className: css(styles.disclosureArrow),
                        ref: function ref(e) {
                            return _this2.arrow = e;
                        },
                        transform: arrowTransform,
                        style: {
                            bottom: this.state.expanded && this.state.belowScreen ? "18px" : "-18px"
                        }
                    },
                    React.createElement(
                        "filter",
                        {
                            id: "definition-widget-dropshadow",
                            height: "150%"
                        },
                        React.createElement("feOffset", {
                            dx: dropShadowXOffset,
                            dy: dropShadowYOffset,
                            result: "offsetblur"
                        }),
                        React.createElement("feGaussianBlur", {
                            "in": "SourceAlpha",
                            stdDeviation: dropShadowRadius / 2
                        }),
                        React.createElement(
                            "feComponentTransfer",
                            null,
                            React.createElement("feFuncA", {
                                type: "linear",
                                slope: dropShadowOpacity
                            })
                        ),
                        React.createElement(
                            "feMerge",
                            null,
                            React.createElement("feMergeNode", null),
                            React.createElement("feMergeNode", { "in": "SourceGraphic" })
                        )
                    ),
                    React.createElement("polyline", {
                        fill: "white",
                        filter: "url(#definition-widget-dropshadow)",
                        points: "0," + arrowHeight + " " + (arrowWidth + "," + arrowHeight + " ") + (arrowWidth / 2 + ",0")
                    })
                )
            ),
            React.createElement(
                "div",
                {
                    className: css(styles.content, isMobile && styles.contentMobile, this.state.expanded && expandedStyle),
                    style: {
                        height: this.state.expanded ? "auto" : 0,
                        overflow: this.state.expanded ? "visible" : "hidden",
                        left: isMobile ? this.state.contentOffsetLeftMobile : this.state.contentOffsetLeft,
                        width: isMobile ? this.state.contentWidthMobile : this.state.contentWidth,
                        marginTop: this.state.contentMarginTop
                    },
                    ref: function ref(e) {
                        return _this2.content = e;
                    }
                },
                React.createElement(Renderer, {
                    apiOptions: this.props.apiOptions,
                    content: this.props.definition,
                    widgets: this.props.widgets
                })
            )
        );
    }
});

var dropShadowXOffset = 0;
var dropShadowYOffset = 1;
var dropShadowOpacity = 0.35;
var dropShadowRadius = 4;

var arrowWidth = 20;
var arrowHeight = 14;
var backgroundColor = styleConstants.white;

var styles = StyleSheet.create({
    container: {
        display: "inline",
        position: "relative"
    },

    linkContainer: {
        display: "inline-block"
    },

    definitionLink: {
        color: styleConstants.blue,
        borderBottom: "dashed 1px " + styleConstants.blue,
        textDecoration: "none"
    },

    mobileDefinitionLink: (_mobileDefinitionLink = {
        color: styleConstants.kaGreen,
        borderBottom: "dashed 1px " + styleConstants.kaGreen,
        textDecoration: "none"

    }, _mobileDefinitionLink[mediaQueries.xl] = {
        fontSize: 22,
        lineHeight: 1.4
    }, _mobileDefinitionLink[mediaQueries.lgOrSmaller] = {
        fontSize: 20,
        lineHeight: 1.5
    }, _mobileDefinitionLink[mediaQueries.smOrSmaller] = {
        fontSize: 18,
        lineHeight: 1.2
    }, _mobileDefinitionLink),

    content: {
        background: backgroundColor,
        opacity: 0.95,
        borderRadius: 1,
        position: "absolute",
        transition: "margin-top 0.1s",
        paddingLeft: styleConstants.phoneMargin,
        paddingRight: styleConstants.phoneMargin,
        zIndex: 2
    },

    contentExpanded: {
        boxShadow: "0px 0px 4px " + styleConstants.gray85,
        border: "solid 0.5px " + styleConstants.gray85
    },

    contentExpandedMobile: {
        paddingTop: 32,
        paddingBottom: 32,
        boxShadow: "0px 0px 4px " + styleConstants.gray85,
        border: "solid 0.5px " + styleConstants.gray85
    },

    disclosureArrow: {
        // HACK - positioning at "bottom: 0", doesn't actually position it to
        // the real bottom, because the container is `inline-block`, and it
        // seems to position it to the baseline? We put in a generous
        // fudge factor to position it down to be flush with the content box
        // below it.
        height: arrowHeight,
        left: "50%",
        marginLeft: -(arrowWidth / 2),
        position: "absolute",
        width: arrowWidth,
        zIndex: 4 // so popovers appear on top
    }
});

_.extend(Definition, {
    validate: function validate(state, rubric) {
        return {
            type: "points",
            earned: 0,
            total: 0,
            message: null
        };
    }
});

module.exports = {
    name: "definition",
    displayName: "Definition",
    defaultAlignment: "inline",
    widget: Definition,
    transform: _.identity
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/definition.jsx
 ** module id = 102
 ** module chunks = 0 1
 **/